<template>
  <div class="container-fluid">
    <Toolbar class="m-2">
      <template #start>
        <h2>{{ $t("nav.specialrequests") }}</h2>
      </template>
    </Toolbar>
    <SpecialRequestTable />
  </div>
</template>

<script>
import SpecialRequestTable from "@/components/specialrequest/SpecialRequestTable.vue";
import Toolbar from "primevue/toolbar";

export default {
  name: 'SpecialRequestView',
  components: {SpecialRequestTable, Toolbar},
  data() {
    return {}
  }
}

</script>
